import React, {useEffect, useState} from "react";
import {AiFillStar} from "react-icons/ai";

export function SingleStar(props: {
    percentage: number;
    onClick?: () => void;
    isHovering?: boolean;
    hoverValue?: number;
    precision: number;
    index: number;
    starSizeClassName?: string;
}) {

    const [hoverPercentage, setHoverPercentage] = useState<number>(0);
    const [percentage, setPercentage] = useState<number>(0);
    const starSizeClassName = props.starSizeClassName ?? "w-6 h-6";

    useEffect(() => {
        if (props.isHovering && props.hoverValue !== undefined) {
            setHoverPercentage(Math.min(1, Math.max(0, props.hoverValue)) * 100);
        } else {
            setPercentage(Math.round(props.percentage / (props.precision * 100)) * (props.precision * 100));
        }
    }, [props.isHovering, props.hoverValue, props.percentage, props.precision]);

    return <div className="flex items-center relative">
        <AiFillStar
            className={[starSizeClassName, "absolute transition-all duration-150", props.isHovering && props.hoverValue !== undefined ? "text-amber-200" : "text-yellow-400"].join(' ')}
            style={{clipPath: "inset(0 " + (100 - (props.isHovering && props.hoverValue !== undefined ? hoverPercentage : percentage)) + "% 0 0)"}}/>
        <AiFillStar className={[starSizeClassName, "text-gray-500"].join(' ')}/>
    </div>
}
